<template>
  <div class="app-container">
    <navigation title="积分记录"></navigation>
    <div class="integral-card">
      <div class="card-cont">
        <ul class="integral-cont">
          <li class="card-num">当前积分：</li>
          <li class="card-money">10000</li>
        </ul>
      </div>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup } from 'vant'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup)

export default {
  name: 'integral',
  components: {navigation, version},
  data () {
    return {
      active: 3
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
  .app-container{
    background:#ecf5fd;
    overflow-y:scroll;
    min-height: calc(100% - 92px);
    position: absolute;
    top: 0px;
    bottom: 0px;
  }
.integral-card{
  width:100%;
  height:3.25rem;
  /*background: linear-gradient(148deg, #00C8DA 0%, #008095 100%);*/
  /*color:#008095;*/
  font-size:.28rem;
  font-family: SourceHanSerifCN-SemiBold;
  margin-top:.92rem;
}
.card-cont{
  /*width:6.59rem;*/
  height:2.61rem;
  padding:.45rem .34rem 0 .35rem;
}
.card-cont ul{
  width: 6.81rem;
  height:2.8rem;
  background-size:100% 100%;
  position:relative;
}
.tip{
  color:#C9CBCD;
  text-align:center;
  font-size:.2rem;
  padding:.25rem 0;
  line-height:.2rem;
  font-family: SourceHanSansCN-Light;
}
.card-num{
  font-size:.28rem;
  padding:.36rem  0 0 .33rem;
}
.card-money{
  text-align:center;
  font-size:.36rem;
}
.card-money{
  text-align:center;
  font-size:.72rem;
  line-height:1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/view/integral/index.vue